const doc = [({"da":({"js":({"admin":({"invoice_lines":({"table":({"vat":"Moms"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;